export default "__VITE_ASSET__B8D9GBP3__";